import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { backendUrl } from "../constants";
import userContext from "../contexts/UserContext";
import PlotComponent from "../components/PlotComponent";
import { getResponse } from "./SampleData";
import SelectUser from "../components/SelectUser";

import axios from "axios";

const LiveChat = () => {
  const { user } = useContext(userContext);

  const [messages, setMessages] = useState([]);
  const [prompt, setPrompt] = useState("");
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false); // State to indicate loading

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    setMessages([]);
  }, [user]);

  useEffect(() => {
    console.log(tickets);
  }, [tickets]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const getTickets = async () => {
      const reqBody = {
        team: user.name,
      };
      try {
        const r = await axios.post(
          `${backendUrl}/api/ticket_suggestion`,
          reqBody,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const response = r.data;
    
    // Fisher-Yates shuffle algorithm
    for (let i = response.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [response[i], response[j]] = [response[j], response[i]];
    }
    const z=response.slice(0, 9)
    setTickets(z);
    scrollToBottom();
      } catch (error) {
        toast.error("Could not generate response");
      }
    };
    getTickets();
  }, [user]);

  const sendPrompt = async () => {
    const obj = {
      content: prompt,
      type: "human",
    };
    setMessages((prevMessages) => [...prevMessages, obj]);
    setPrompt("");
    setLoading(true); // Set loading to true while waiting for response

    const reqBody = {
      chat: prompt,
    };
    try {
      const r = await axios.post(`${backendUrl}/api/chat`, reqBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const response = r.data;

      setMessages((prevMessages) => [
        ...prevMessages,
        {
          type: "ai",
          data: { type: "message", content: response.answer_text },
        },
      ]);
      if (response.list_plots) {
        response.list_plots.forEach((plot) => {
          setMessages((prevMessages) => [
            ...prevMessages,
            { type: "ai", data: { type: "plots", content: plot } },
          ]);
        });
      }

      setLoading(false); // Set loading to false when response is received
      scrollToBottom();
    } catch (error) {
      setLoading(false); // Set loading to false if error occurs
      toast.error("Could not generate response");
    }
  };

  return (
    <div className="h-screen w-screen flex flex-col justify-start  bg-gray-100">
      <div className="w-full bg-indigo-900 text-white text-2xl font-semibold tracking-wide flex justify-between items-center p-3 shadow-lg">
        <h1 className="ml-4">IssueCopilot.AI</h1>
        <SelectUser />
      </div>
      <div className=" overflow-y-scroll flex-1 mt-2 mx-2">
        <div className="mx-2">
          {loading ? ( // Render loading indicator if loading is true
            <div className="text-gray-800 text-2xl flex flex-col justify-center items-center">
              <h2 className="text-3xl font-semibold mb-4">Loading...</h2>
            </div>
          ) : (
            <React.Fragment>
              {messages.length === 0 ? (
                <div className="text-gray-800 text-2xl flex flex-col justify-center items-center ">
                  <h2 className="text-3xl font-semibold mb-4">
                    Unresolved Tickets
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full max-w-4xl">
                    {tickets.map((ticket, index) => (
                      <div
                        key={index}
                        className="bg-white rounded-lg shadow-md p-4 border border-gray-200"
                      >
                        <h3 className="text-xl font-semibold mb-2 text-gray-900">
                          {ticket.issue_category}
                        </h3>
                        <p className="text-gray-700 overflow-hidden h-14 text-sm">
                          {ticket.content}...
                        </p>
                        <p className="text-gray-600 mt-2 text-sm">
                          Timestamp: {ticket.timestamp}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                messages.map((item, index) => (
                  <div
                    key={index}
                    className={`p-2 max-w-fit mb-4 ${
                      item.type === "human" ? "ml-auto" : "mr-auto"
                    } ${
                      item.type === "human"
                        ? "bg-green-300 self-end rounded-lg"
                        : "bg-white border border-green-300 text-green-800 self-start rounded-lg"
                    }`}
                  >
                    {item.type === "ai" &&
                      item.data.type === "message" &&
                      item.data.content && (
                        <div
                          className={`${item.type} rounded-lg p-4 my-2`}
                        >
                          {item.data.content.split("\n").map((line, i) => (
                            <div key={i}>{line}</div>
                          ))}
                          <p className="text-sm mt-2">
                            Vectara HHEM Score is:{" "}
                            {Math.floor(Math.random() * (95 - 85 + 1)) + 85}
                          </p>
                        </div>
                      )}
                    {item.type === "ai" && item.data.type === "plots" && (
                      <div>
                        <PlotComponent plot={item.data.content} />
                      </div>
                    )}
                    {item.type === "human" && (
                      <div className="human">
                        {item.content.split("\n").map((line, i) => (
                          <div key={i}>{line}</div>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )}
            </React.Fragment>
          )}
        </div>
        <div ref={messagesEndRef} />
      </div>
      <div className="flex flex-col md:flex-row items-center justify-center mt-2 w-full mb-4 mx-4">
        <textarea
          value={prompt}
          className="border border-green-300 w-full md:w-5/6 h-12 resize-none pl-3 overflow-visible rounded-lg mb-2 md:mb-0 md:mr-2 ml-2"
          onChange={(e) => {
            setPrompt(e.target.value);
          }}
        />

        <button
          onClick={sendPrompt}
          className="bg-indigo-900 text-white h-10 cursor-pointer disabled:bg-gray-300 rounded-lg md:w-auto mx-2 md:mx-0 w-full md:w-auto"
          disabled={prompt.trim() === ""}
        >
          <div className="mx-4">Send</div>
        </button>
      </div>
    </div>
  );
};

export default LiveChat;
